<li>
    <ng-content></ng-content>
</li>